module.exports = __webpack_public_path__ + "static/video3-3dd4385719e2d372ae8e1eac7cec72f9.png";